import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";
import {SharedModule} from "../shared/shared.module";
import {PrettyJsonModule} from "angular2-prettyjson";
import {EducationRoutingModule} from "./education-routing.module";
import {MatChipsModule} from "@angular/material/chips";
import { AddIdividualEducationComponent } from './components/add-idividual-education/add-idividual-education.component';
import { AddGroupEducationComponent } from './components/add-group-education/add-group-education.component';
import { ViewEducationIndividualComponent } from './components/view-education-individual/view-education-individual.component';
import { ViewEducationGroupComponent } from './components/view-education-group/view-education-group.component';
import { AllEducationSessionComponent } from './components/all-education-session/all-education-session.component';
import { EducationTableGroupComponent } from './components/education-group-table/education-table-group.component';
import {
  EducationTableIndividualComponent
} from "./components/education-individual-table/education-table-individual.component";
import { EditIndividualEducationComponent } from './components/edit-individual-education/edit-individual-education.component';
import { EditGroupEducationComponent } from './components/edit-group-education/edit-group-education.component';
import { SelectAllComponent } from './components/select-all/select-all.component';
import { EducationReportingDashboardComponent } from './education_reporting/education-reporting-dashboard/education-reporting-dashboard.component';
import { EducationIndividualReportingComponent } from './education_reporting/education-individual-reporting/education-individual-reporting.component';
import { EducationGroupReportingComponent } from './education_reporting/education-group-reporting/education-group-reporting.component';
import { EducationChildReportComponent } from './education-child-report/education-child-report.component';
import { FollowUpQuestionComponent } from './components/follow-up-question/follow-up-question.component';
import { FollowUpTableComponent } from './components/follow-up-question/follow-up-table/follow-up-table.component';
import { ViewFollowUpEducationComponent } from './components/view-follow-up-education/view-follow-up-education.component';
import {
  AddEditEducationObservationComponent
} from "./components/educationObservation/add-edit-education-observation/add-edit-education-observation.component";
import {
  EducationObservationListComponent
} from "./components/educationObservation/education-observation-list/education-observation-list.component";
import {ComponentsModule} from "../shared/components/components.module";
import { ViewEducationObservationComponent } from './components/educationObservation/view-education-observation/view-education-observation.component';
import {WorkUpdateListComponent} from "./components/Work Update/work-update-list/work-update-list.component";
import {AddEditWorkUpdateComponent} from "./components/Work Update/add-edit-work-update/add-edit-work-update.component";
import { AddEditInductionComponent } from './components/induction/add-edit-induction/add-edit-induction.component';
import { InductionListComponent } from './components/induction/induction-list/induction-list.component';
import { ViewInductionComponent } from './components/induction/view-induction/view-induction.component';
import { SpecialDayListComponent } from './components/special-day/special-day-list/special-day-list.component';
import { AddEditSpecialDayComponent } from './components/special-day/add-edit-special-day/add-edit-special-day.component';
import { ViewSpecialDayComponent } from './components/special-day/view-special-day/view-special-day.component';
import { AddEditEducationMomComponent } from './components/education-mom/add-edit-education-mom/add-edit-education-mom.component';
import { EducationMomListComponent } from './components/education-mom/education-mom-list/education-mom-list.component';
import { ViewEducationMomComponent } from './components/education-mom/view-education-mom/view-education-mom.component';
import { EducationInductionTableComponent } from './components/induction/education-induction-table/education-induction-table.component';
import { EducationWorkUpdateViewComponent } from './components/Work Update/education-work-update-view/education-work-update-view.component';
import { AddParticipantsDialogComponent } from './components/education-mom/add-participants-dialog/add-participants-dialog.component';
import { EducationHighlightComponent } from './components/education-highlight/education-highlight.component';
import { ViewEducationHighlightComponent } from './components/view-education-highlight/view-education-highlight.component';
import { AgGridModule } from 'ag-grid-angular';
import {
    EducationIndividualActionsRendererComponent
} from './components/education-individual-table/education-individual-actions-renderer.component';


@NgModule({
    declarations: [
        EducationTableIndividualComponent,
        AddIdividualEducationComponent,
        AddGroupEducationComponent,
        ViewEducationIndividualComponent,
        ViewEducationGroupComponent,
        AllEducationSessionComponent,
        EducationTableGroupComponent,
        EditIndividualEducationComponent,
        EditGroupEducationComponent,
        SelectAllComponent,
        EducationReportingDashboardComponent,
        EducationIndividualReportingComponent,
        EducationGroupReportingComponent,
        EducationChildReportComponent,
        FollowUpQuestionComponent,
        FollowUpTableComponent,
        ViewFollowUpEducationComponent,
        EducationObservationListComponent,
        AddEditEducationObservationComponent,
        ViewEducationObservationComponent,
        WorkUpdateListComponent,
        AddEditWorkUpdateComponent,
        AddEditInductionComponent,
        InductionListComponent,
        ViewInductionComponent,
        SpecialDayListComponent,
        AddEditSpecialDayComponent,
        ViewSpecialDayComponent,
        AddEditEducationMomComponent,
        EducationMomListComponent,
        ViewEducationMomComponent,
        EducationInductionTableComponent,
        EducationWorkUpdateViewComponent,
        AddParticipantsDialogComponent,
        EducationHighlightComponent,
        ViewEducationHighlightComponent,
        EducationIndividualActionsRendererComponent
    ],
    exports: [
        SelectAllComponent,
        AddParticipantsDialogComponent
    ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    EducationRoutingModule,
    PrettyJsonModule,
    ComponentsModule,
    MatChipsModule,
    AgGridModule,
    // AppModule
  ]
})
export class EducationModule { }
